import { businessCustomerActionTypes } from "../../actionTypes/businessCustomer/businessCustomer.actionTypes";

const initialState = {
  stateInfo: {
    isLoading: false,
    isSuccess: false,
    isError: false,
    error: null,
  },
  businessCustomers: [],
};

const businessCustomerReducer = (state = initialState, action) => {
  switch (action.type) {
    case businessCustomerActionTypes.START_FETCH_CUSTOMERS:
      return setStateLoading(state);

    case businessCustomerActionTypes.FETCH_CUSTOMERS_SUCCESS:
      return setFetchSuccess(state, action);

    case businessCustomerActionTypes.FETCH_CUSTOMERS_FAILURE:
      return setStateFailure(state, action);

    default:
      return state;
  }
};

// Helper functions

const setStateLoading = (state) => ({
  ...state,
  stateInfo: {
    isLoading: true,
    isSuccess: false,
    isError: false,
    error: null,
  },
});

const setFetchSuccess = (state, action) => ({
  ...state,
  stateInfo: {
    isLoading: false,
    isSuccess: true,
    isError: false,
    error: null,
  },
  businessCustomers: action.data,
});

const setStateFailure = (state, action) => ({
  ...state,
  stateInfo: {
    isLoading: false,
    isSuccess: false,
    isError: true,
    error: action.error,
  },
});

export default businessCustomerReducer;
